import { createContext } from "react";
import { ExtendedFile } from "~graphql/typed-document-nodes";

export interface OrderSummaryData {
  title: string;
  subtitle?: string;

  image?: ExtendedFile;
  renderLineItems: () => JSX.Element;
  renderServiceCosts: () => JSX.Element;
  renderTotals: () => JSX.Element;

  isLoading: boolean;
  setLoading: (setLoading: boolean) => void;
  addToQueue: (id: string, callback: () => Promise<void>) => void;

  totalServiceCost: number;
  allowPromoCode?: boolean;
  isPromoCodeApplied?: boolean;
}

export const OrderSummaryContext = createContext<OrderSummaryData | undefined>(
  undefined
);
